import { toast } from "../../toasts";

export const showErrorToast = () => {
  toast.error("Failed to save changes");
};

export const showAppointmentCreatedToast = () => {
  toast.success("Appointment added!");
};

export const showAppointmentUpdatedToast = () => {
  toast.success("Appointment updated!");
};
